import BrandLogo0 from "../../../assets/web/images/logo-0.png";
import BrandLogo1 from "../../../assets/web/images/logo-1.png";
import BrandLogo2 from "../../../assets/web/images/logo-2.png";
import BrandLogo3 from "../../../assets/web/images/logo-3.png";
import BrandLogo4 from "../../../assets/web/images/logo-4.png";
import BrandLogo5 from "../../../assets/web/images/logo-5.png";
import Shape4 from "../../../assets/web/images/shape-4.svg";
import Shape5 from "../../../assets/web/images/shape-5.svg";
import VideoThumbnail from "../../../assets/web/images/video-thumbnail.png";
import Container from "../Container";

const VideoBanner = () => {
  const brandLogos = [
    BrandLogo0,
    BrandLogo1,
    BrandLogo2,
    BrandLogo3,
    BrandLogo4,
    BrandLogo5,
  ];

  return (
    <section className="bg-[#FFF9F6] py-20">
      <Container>
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
            {brandLogos.map((logo, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-md shadow-md flex items-center justify-center"
              >
                <img src={logo} className="w-full" alt="Sheba" />
              </div>
            ))}
          </div>

          <div className="mt-16 mb-12 text-3xl md:text-5xl font-bold text-center text-textHeading">
            <span className="md:block">
              <span className="relative z-0">
                <span>Achieve</span>{" "}
                <img
                  src={Shape4}
                  alt=""
                  className="absolute bottom-0 left-0 -z-10"
                />
              </span>
              excellence in
            </span>
            <span className="">
              every{" "}
              <span className="relative">
                <span className="relative z-10">task.</span>
                <img
                  src={Shape5}
                  alt=""
                  className="absolute bottom-0 right-0"
                />
              </span>
            </span>
          </div>
          <div>
            <img src={VideoThumbnail} alt="VideoThumbnail" className="w-full" />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default VideoBanner;
